import {gql} from '@apollo/client';

const UPDATE_COUNTRY = gql`
  mutation updateCountry(
    $id: ID!
    $name: String!
    $businessRegion: String!
    $currency: Currency!
    $repairCostDimension: ValueDimension!
    $maintenanceCostDimension: ValueDimension!
    $countryCodes: [String!]!
  ) {
    updateCountry(
      input: {
        id: $id
        name: $name
        businessRegion: $businessRegion
        currency: $currency
        repairCostDimension: $repairCostDimension
        maintenanceCostDimension: $maintenanceCostDimension
        countryCodes: $countryCodes
      }
    ) {
      id
      name
      businessRegion
      currency
      repairCostDimension
      maintenanceCostDimension
      countryCodes
    }
  }
`;

export default UPDATE_COUNTRY;
